import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { ResumeService } from 'src/app/core/services/resume.service';

declare var JSZip: any;
declare var saveAs: any;

@Component({
  selector: 'app-export-candidate-documents',
  templateUrl: './export-candidate-documents.component.html',
  styleUrls: ['./export-candidate-documents.component.css']
})
export class ExportCandidateDocumentsComponent implements OnInit {

  @Input() jobMatchId;
  @Input() jobMatchInfo;
  @Input() isCandidateExportInfo
  @Output() cancelCallback = new EventEmitter<any>();

  @ViewChild('ngForm', null) ngForm:NgForm;

  files: any = [];
  selectedFiles: any = [];
  generalFileName: any = '';
  zipFileName: any = '';
  companyId: any = '';
  resumeHrXmlFileName: any = '';
  fetches: any= [];
  taFileName: any;
  vaFileName: any;
  recruiterScreeningFileName: any;
  phoneScreeningFileName: any;
  isRecruiterScreeningFeedbackAvailable: any;
  isPhoneScreenFeedbackAvailable: any;
  isInterviewFeedbackAvailable: any;
  interviewFeedbackFileName: any;
  resumeUrl: any;
  resumeHrXmlUrl: any;
  taUrl: any;
  vaUrl: any;
  recruiterScreeningFeedbackUrl: any;
  phoneScreenFeedbackUrl: any;
  interviewFeedbackUrl: any;


  isLoading: boolean = true;
  isExportingInProgress: boolean = false;
  isCorporateFlag: boolean = false;
  sectionalReport: boolean = false;

  constructor(
    private authService: AuthService,
    private companyService: CompanyService,
    private jobMatchService: JobMatchService,
    private resumeService: ResumeService,
    private alertsAndNotificationsService: AlertAndNotificationsService
  ) { }

  ngOnInit() {
    this.companyId = this.authService.getUserDetails().company.companyId;
    this.isCorporateFlag = this.companyService.isCorporateCompany();

    this._checkAvailableFeedbackReports(() => {
      this._initFileNames();
      this._loadFiles();
    });
  }

  _checkAvailableFeedbackReports(successCallback) {
    this.isLoading = true;
    this.jobMatchService.getFeedbackReportsAvailability(this.jobMatchId, this.companyId, (data) => {
      let feedbackReports = data.feedbackReportsAvailability;
      this.isRecruiterScreeningFeedbackAvailable = feedbackReports["recruiterScreeningFeedbackReport"];
      this.isPhoneScreenFeedbackAvailable = feedbackReports["phoneScreenFeedbackReport"];
      this.isInterviewFeedbackAvailable = feedbackReports["interviewFeedbackReport"];
      if (successCallback) {
        successCallback();
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });

  }

  _initFileNames() {
    this.generalFileName = this.jobMatchInfo.name + '-' + this.jobMatchInfo.jobMatchTitle;
    this.zipFileName = this.generalFileName + '.zip';
    this.resumeHrXmlFileName = this.jobMatchInfo.name + '-' + 'hrxml.xml';
    this.taFileName = this.generalFileName + '-' + this.jobMatchInfo.techAssessmentName + '.pdf';
    this.vaFileName = this.generalFileName + '-' + this.jobMatchInfo.valueAssessmentName + '.pdf';
    this.recruiterScreeningFileName = this.generalFileName + '-RecruiterScreening' + '.pdf';
    this.phoneScreeningFileName = this.generalFileName + '-PhoneScreen' + '.pdf';
    this.interviewFeedbackFileName = this.generalFileName + '-InterviewFeedback' + '.pdf';
  }

  _loadFiles() {
    this.sectionalReport = false;
    if (this.jobMatchInfo.isSharedRequisition && !this.isCorporateFlag) {
      this.sectionalReport = true;
    }

    if (!_.isNull(this.jobMatchInfo.resumePdfFileName)) {
      this.resumeUrl = this.resumeService.getResumeDocumentUrl(this.jobMatchInfo.id) + "?fileFormat=pdf"
      this.files.push({ name: 'Resume', fileName: this.jobMatchInfo.resumePdfFileName, url: this.resumeUrl, isSelected: true });
      this.resumeHrXmlUrl = this.resumeService.getResumeHrXmlDocumentUrl(this.jobMatchInfo.id);
      this.files.push({ name: 'Resume HR Xml', fileName: this.resumeHrXmlFileName, url: this.resumeHrXmlUrl, isSelected: true });
    }

    if (!_.isNull(this.jobMatchInfo.techAssessmentPdfReportURL) && !_.isNull(this.jobMatchInfo.techAssessmentScore) && this.jobMatchInfo.techAssessmentScore.toString() != '') {
      this.taUrl = 'api/candidate/candidatepdfreport?filepath=' + this.jobMatchInfo.techAssessmentPdfReportURL + '&testinvitationid=' + this.jobMatchInfo.testInvitationId + '&sectional=' + this.sectionalReport;
      this.files.push({ name: 'Tech Assessment', fileName: this.taFileName, url: this.taUrl, isSelected: true });
    }

    if (!_.isNull(this.jobMatchInfo.valueAssessmentPdfReportURL) && !_.isNull(this.jobMatchInfo.valueAssessmentScore) && this.jobMatchInfo.valueAssessmentScore.toString() != '') {
      this.vaUrl = 'api/candidate/candidatepdfreport?filepath=' + this.jobMatchInfo.valueAssessmentPdfReportURL + '&testinvitationid=' + this.jobMatchInfo.testInvitationId + '&sectional=' + this.sectionalReport;
      this.files.push({ name: "Value Assessment", fileName: this.vaFileName, url: this.vaUrl, isSelected: true });
    }

    if (this.isRecruiterScreeningFeedbackAvailable) {
      this.recruiterScreeningFeedbackUrl = "api/jobmatch/getscreeningfeedbackreport/" + this.jobMatchId + "?isAttachment=true&companyId=" + this.companyId;
      this.files.push({ name: " Recruiter Screening Feedback", fileName: this.recruiterScreeningFileName, url: this.recruiterScreeningFeedbackUrl, isSelected: true });
    }
    if (this.isPhoneScreenFeedbackAvailable) {
      this.phoneScreenFeedbackUrl = "api/jobmatch/getphonescreenfeedbackreport/" + this.jobMatchId + "?isAttachment=true&companyId=" + this.companyId;
      this.files.push({ name: "Phone Screen Feedback", fileName: this.phoneScreeningFileName, url: this.phoneScreenFeedbackUrl, isSelected: true });
    }

    if (this.isInterviewFeedbackAvailable) {
      this.interviewFeedbackUrl = "api/jobmatch/getinterviewfeedbackreport/" + this.jobMatchId + "?isAttachment=true&companyId=" + this.companyId;
      this.files.push({ name: "Interview Feedback", fileName: this.interviewFeedbackFileName, url: this.interviewFeedbackUrl, isSelected: true });
    }

    this.isLoading = false;
  }

  exportFiles() {
    this.isExportingInProgress = true;
    this.selectedFiles = _.filter(this.files, { isSelected: true });
    if (this.selectedFiles.length > 1) {
      this._createZipAndExport();
    } else if (this.selectedFiles.length == 1) {
      this._exportFile();
    } else {
      this.isExportingInProgress = false;
      this.alertsAndNotificationsService.showBannerMessage('No Document selected', 'danger');
    }
  }

  _createZipAndExport() {
    this.fetches = [];
    this._getDocs(0);
  }

  _getDocs(index) {
    if (this.selectedFiles.length > index) {
      fetch(this.selectedFiles[index].url).then((response) => {
        if (response.status === 200) {
          this.fetches.push(response.blob());
          if (this.selectedFiles.length == this.fetches.length) {
            this._generateZipFolder();
          } else {
            this._getDocs(index + 1);
          }
        } else {
          this.alertsAndNotificationsService.showBannerMessage('Exporting document failed', 'danger');
        }
      });
    }
  }

  _generateZipFolder() {
    let zip = new JSZip();
    let folder = zip.folder(this.generalFileName);
    angular.forEach(this.selectedFiles, (file, key) => {
      folder.file(file.fileName, this.fetches[key]);
    });
    zip.generateAsync({ type: "blob" })
      .then((blob) => {
        this.isExportingInProgress = false;
        saveAs(blob, this.zipFileName);
        this.cancelCallback.emit();
      })
      .catch((error) => {
        this.alertsAndNotificationsService.showBannerMessage('Documents export failed', 'danger');
      });
  }

  _exportFile() {
    let link = document.createElement("a");
    link.download = this.selectedFiles[0].fileName;
    link.href = this.selectedFiles[0].url;
    link.click();
    this.isExportingInProgress = false;
  }

  cancel() {
    this.cancelCallback.emit();
  }

}
